import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useAuthStore } from '../stores/authStore'
import {
  LayoutDashboard,
  Shield,
  Users,
  Settings,
  DollarSign,
  FileText,
  Truck,
  Menu,
  X,
  LogOut,
  ChevronDown,
  User,
  Building2,
  Calendar,
  Wallet,
  Bell
} from 'lucide-react'
import './Layout.css'

const menuItems = [
  { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/guard-operations', icon: Shield, label: 'Guard Operations' },
  { path: '/personnel', icon: Users, label: 'Personnel' },
  { path: '/administration', icon: Settings, label: 'Administration' },
  { path: '/finance', icon: DollarSign, label: 'Finance' },
  { path: '/records', icon: FileText, label: 'Records' },
  { path: '/supply-chain', icon: Truck, label: 'Supply Chain' },
  { path: '/record-pull', icon: FileText, label: 'Record Pull' },
  { path: '/client-area', icon: Building2, label: 'Client Area' },
  { path: '/off-duty', icon: Calendar, label: 'Off Days' },
  { path: '/advance-payments', icon: Wallet, label: 'Advance Payments' },
  { path: '/payroll', icon: DollarSign, label: 'Payroll' },
]
const roleMenuAccess = {
  admin: ['/', '/guard-operations', '/personnel', '/administration', '/finance', '/records', '/supply-chain', '/record-pull', '/client-area', '/off-duty', '/advance-payments', '/payroll'],
  hr: ['/', '/guard-operations', '/personnel', '/administration', '/finance', '/records', '/supply-chain', '/record-pull', '/client-area', '/off-duty', '/advance-payments', '/payroll'],
  supervisor: ['/', '/guard-operations', '/personnel', '/administration', '/finance', '/records', '/supply-chain', '/record-pull', '/client-area', '/off-duty', '/advance-payments', '/payroll'],
  finance: ['/', '/guard-operations', '/personnel', '/administration', '/finance', '/records', '/supply-chain', '/record-pull', '/client-area', '/off-duty', '/advance-payments', '/payroll'],
  assistant_hr: ['/', '/guard-operations', '/personnel', '/administration', '/finance', '/records', '/supply-chain', '/record-pull', '/client-area', '/off-duty', '/advance-payments', '/payroll']
}

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(true)
  const [profileOpen, setProfileOpen] = useState(false)
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className={`layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="logo">
            <div className="logo-icon">
              <Shield size={32} />
            </div>
            <div className="logo-text">
              <span className="logo-title">Gismac</span>
              <span className="logo-subtitle">Security</span>
            </div>
          </div>
          <button 
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>

                <nav className="sidebar-nav">
          {menuItems.filter(item => {
            const allowedPaths = roleMenuAccess[user?.role] || roleMenuAccess.admin
            return allowedPaths.includes(item.path)
          }).map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => 
                `nav-link ${isActive ? 'active' : ''}`
              }
            >
              <item.icon size={20} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">
              <User size={20} />
            </div>
            <div className="user-details">
              <span className="user-name">{user?.firstName} {user?.lastName}</span>
              <span className="user-role">{user?.role?.replace('_', ' ').toUpperCase()}</span>
            </div>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        {/* Header */}
        <header className="header">
          <div className="header-left">
            <button 
              className="menu-btn"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <Menu size={20} />
            </button>
            <h1 className="page-title">Dashboard</h1>
          </div>

          <div className="header-right">
            <button className="notification-btn">
              <Bell size={20} />
              <span className="notification-badge">3</span>
            </button>

            <div className="profile-dropdown">
              <button 
                className="profile-btn"
                onClick={() => setProfileOpen(!profileOpen)}
              >
                <div className="profile-avatar">
                  <User size={18} />
                </div>
                <span>{user?.firstName}</span>
                <ChevronDown size={16} />
              </button>

              {profileOpen && (
                <div className="dropdown-menu">
                  <NavLink to="/administration" className="dropdown-item">
                    <User size={16} />
                    Profile
                  </NavLink>
                  <button onClick={handleLogout} className="dropdown-item logout">
                    <LogOut size={16} />
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* Page Content */}
        <div className="page-content">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
